module.exports = __webpack_public_path__ + "media/images/emblems/Saint-Prex-coat_of_arms-601e7dbb0136e183d824bc0826f050e2.svg";